@if (!item.hidden) {
    @if (!item.url && !item.function) {
        <a [id]="'nav-link-' + item.id"
           tabindex="0"
           class="nav-link"
           [ngClass]="item.classes"
           (click)="toggleOpen($event)"
           (keydown.enter)="toggleOpen($event)">
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.url -->
    @if (item.url && !item.externalUrl && !item.function) {
        <a
            tabindex="0"
            [id]="'nav-link-' + item.id"
            class="nav-link"
            [ngClass]="item.classes"
            (click)="toggleOpen($event)"
            [routerLink]="[item.url]"
            [routerLinkActive]="['active', 'accent']"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.externalUrl -->
    @if (item.url && item.externalUrl && !item.function) {
        <a
            tabindex="0"
            [id]="'nav-link-' + item.id"
            class="nav-link"
            [ngClass]="item.classes"
            (click)="toggleOpen($event)"
            [href]="item.url"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.function -->
    @if (!item.url && item.function) {
        <span
            tabindex="0"
            [id]="'nav-link-' + item.id"
            class="nav-link"
            [ngClass]="item.classes"
            (click)="toggleOpen($event); item.function()"
            (keydown.enter)="toggleOpen($event); item.function()"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </span>
    }
    <!-- item.url && item.function -->
    @if (item.url && !item.externalUrl && item.function) {
        <a
            tabindex="0"
            [id]="'nav-link-' + item.id"
            class="nav-link"
            [ngClass]="item.classes"
            (click)="toggleOpen($event); item.function()"
            [routerLink]="[item.url]"
            [routerLinkActive]="['active', 'accent']"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.externalUrl && item.function -->
    @if (item.url && item.externalUrl && item.function) {
        <a
            tabindex="0"
            [id]="'nav-link-' + item.id"
            class="nav-link"
            [ngClass]="item.classes"
            (click)="toggleOpen($event); item.function()"
            [href]="item.url"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <ng-template #itemContent>
        @if (item.icon) {
            <mat-icon class="nav-link-icon">{{ item.icon }}</mat-icon>
        }
        <span class="nav-link-title" [translate]="item.translate">{{ item.title }}</span>
        @if (item.badge) {
            <span
                class="nav-link-badge"
                [translate]="item.badge.translate"
                [ngStyle]="{ 'background-color': item.badge.bg, color: item.badge.fg }"
            >
                {{ item.badge.title }}
            </span>
        }
        <mat-icon class="collapsable-arrow">keyboard_arrow_right</mat-icon>
    </ng-template>
    <div class="children" [style.display]="isOpen ? 'block' : 'none'">
        <div class="content">
            @for (item of item.children; track $index) {
                @switch (item.type) {
                    @case ('item') {
                        <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
                    }
                    @case ('collapsable') {
                        <fuse-nav-vertical-collapsable [item]="item"></fuse-nav-vertical-collapsable>
                    }
                    @case ('group') {
                        <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
                    }
                }
            }
        </div>
    </div>
}
